<div
	class="pill-toggle"
	role="group"
	[attr.aria-label]="ariaLabel | translate">
	@for (option of options; track option.value) {
		<div class="pill-toggle-option" [class]="option.class">
			<button
				type="button"
				class="pill-toggle-button"
				[class.is-selected]="selectedOption === option.value"
				[attr.aria-pressed]="selectedOption === option.value"
				[attr.data-cy]="'pill-toggle-' + option.value"
				(click)="onOptionSelect.emit(option.value)">
				{{ option.label | translate }}
			</button>
		</div>
	}
</div>
